var WebFont = require('webfontloader');
require('picturefill');
require('lazysizes');

declare var WebFontConfig: Object;

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e) {
  var target:HTMLElement = <HTMLElement>e.target;
  var bg = target.getAttribute('data-bg');

  if (bg) {
    target.style.backgroundImage = 'url(' + bg + ')';
  }
});

WebFont.load(WebFontConfig);
